import { Box, Grid, Typography } from "@mui/material";
import CardBasic from "../../../../components/generic/card";
import { useContext, useEffect, useMemo, useRef } from "react";
import BoxTheme from "../../../../components/generic/box";
import PieChart from "../../../../components/charts/pieChart";
import { ThemeContext } from "../../../../contexts/ThemeContext";
import { FilterContext } from "../../contexts/FilterContext";
import TableDashboard from "../tableDashboard";
import "./index.css"

export default function DashFinalized() {

    const { menu } = useContext(ThemeContext)

    const { filter,
        report2,
        resumo,
        setHeight,
    } = useContext(FilterContext)
    const refPieChart = useRef()

    useEffect(() => {
        const height = !!refPieChart?.current?.offsetHeight ? `${refPieChart?.current?.offsetHeight}px` : "45%"
        setHeight(height)
        return () => {
      
        }
    },[refPieChart?.current?.offsetHeight]) 

    return (
        <Grid item className={menu ? "col-dashboard active" : "col-dashboard"} sx={{ padding: "0px !important" }}>
            <CardBasic sx={{ minWidth: "350px", height: "100%", padding: "0", paddingTop: "8px" }}>
                <BoxTheme sx={{ display: "flex", flexDirection: 'column', justifyContent: "space-between" }}>
                    <Typography sx={{ color: "#2c4992", fontWeight: 'bold', fontSize: "1rem", textAlign: "center", marginBottom: "5x" }}>
                        Finalizados
                    </Typography>
                    <BoxTheme sx={{ display: "flex", flexDirection: 'column', justifyContent: "space-between", alignItems: "center", gap: "50px" }} >
                        <Box overflow-x='scroll' sx={{ width: "375", height: "375", display: "flex", justifyContent: "center" }} ref={refPieChart}>
                            <PieChart data={report2}></PieChart>
                        </Box>
                        <TableDashboard data={report2} enterpriseSelected={filter?.enterpriseSelected} ></TableDashboard>
                    </BoxTheme>
                </BoxTheme>
            </CardBasic>
        </Grid>
    )
}